'use client';

import React, { useState } from 'react';
import LoginForm from './LoginForm';
import SignUpForm from './SignUpForm';
import EditorialPanel from './EditorialPanel';

export default function AuthSurface() {
  const [mode, setMode] = useState<'login' | 'signup'>('login');

  return (
    <div className="min-h-screen flex bg-obsidian">
      {/* Left Editorial Panel */}
      <EditorialPanel />

      {/* Right Form Panel */}
      <div className="w-full lg:w-[45%] xl:w-[40%] flex flex-col min-h-screen">
        {/* Top brand bar on mobile */}
        <div className="lg:hidden flex items-center justify-center h-16 border-b border-muted px-6">
          <span className="font-editorial text-sm tracking-widest uppercase text-cream">
            The Private World <span className="text-gold">of Luxury</span>
          </span>
        </div>

        <div className="flex-1 flex items-center justify-center px-8 xl:px-16 py-12">
          <div className="w-full max-w-md">
            {/* Mode Toggle */}
            <div className="flex mb-10 border border-muted rounded-sm overflow-hidden">
              <button
                onClick={() => setMode('login')}
                className={`flex-1 py-3 text-sm tracking-widest uppercase transition-all duration-300 ${
                  mode === 'login' ?'gold-gradient-bg text-obsidian font-semibold' :'text-muted-foreground hover:text-cream bg-transparent'
                }`}
              >
                Member Login
              </button>
              <button
                onClick={() => setMode('signup')}
                className={`flex-1 py-3 text-sm tracking-widest uppercase transition-all duration-300 ${
                  mode === 'signup' ?'gold-gradient-bg text-obsidian font-semibold' :'text-muted-foreground hover:text-cream bg-transparent'
                }`}
              >
                Apply for Membership
              </button>
            </div>

            {mode === 'login' ? (
              <LoginForm onSwitchMode={() => setMode('signup')} />
            ) : (
              <SignUpForm onSwitchMode={() => setMode('login')} />
            )}
          </div>
        </div>

        {/* Footer */}
        <div className="px-8 xl:px-16 pb-8 text-center">
          <p className="text-xs text-muted-foreground tracking-wide">
            © 2026 The Private World of Luxury. All discoveries are curated exclusively for members.
          </p>
          <div className="flex items-center justify-center gap-4 mt-2">
            <button className="text-xs text-muted-foreground hover:text-gold transition-colors">Privacy</button>
            <span className="text-muted-foreground">·</span>
            <button className="text-xs text-muted-foreground hover:text-gold transition-colors">Terms of Membership</button>
            <span className="text-muted-foreground">·</span>
            <button className="text-xs text-muted-foreground hover:text-gold transition-colors">Contact</button>
          </div>
        </div>
      </div>
    </div>
  );
}